/**
 * Created by alex on 01/03/2025.
 * Description:
 * AppendEntityConfirmDialog Component
 * ------ maintenance history ------
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageService } from '../../services/message.service';
import { MessageType } from '../../tamalelibs/models/message.model';
import { AppendEntityFailedNote } from './append-entity-confirm-dialog.model';

@Component({
    selector: 'tam-append-entity-confirm-dialog',
    templateUrl: './append-entity-confirm-dialog.component.html',
    styleUrls: ['./append-entity-confirm-dialog.component.scss'],
})
export class AppendEntityConfirmDialogComponent implements OnInit, OnDestroy {
    //#region public properties
    dialogOpened = false;
    appendEntityFailedNotes: Array<AppendEntityFailedNote> = [];

    /**
    * the subscription array that would be unsubscribed on destroying.
    */
    private _destroySubscriptions: Array<Subscription> = [];

    //#endregion

    constructor(
        private _messageService: MessageService,
    ) { }

    //#region public methods

    ngOnInit() {
        this._destroySubscriptions.push(
            // Get notification by websocket.
            this._messageService.messageSubject$.subscribe(action => this._onMessageAction(action)),
        );
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this._destroySubscriptions = [];
    }

    clickCancel() {
        this.dialogOpened = false;
    }

    /**
     * Get information from web socket
     * @param action 
     */
    private _onMessageAction(action) {
        this.appendEntityFailedNotes = [];
        if (action.type === MessageType.APPEND_ENTITIES) {
            const results = action?.payload?.results;
            if (results && results?.total !== results.successfulEntryIDTotal) {
                if (Array.isArray(results.details)) {
                    results.details.forEach(item => {
                        this.appendEntityFailedNotes.push(new AppendEntityFailedNote(item.ID, item.calculatedTitle || item.title, item.message));
                    });
                    this.dialogOpened = true;
                }
            }
        }
    }
}
